import styled from 'styled-components';

export const LoadingListNoticeDetail = styled.div`
  width: 105.25rem;
  height: calc(100vh - 10rem);
  position: absolute;
  background: rgb(255, 255, 255, 0.8);
  z-index: 5;
  display: flex;
  align-items: center;
  left: 0;
  margin-top: -1rem;
`;
